// eslint-disable-next-line import/no-anonymous-default-export
// стили для компонета typography material ui
export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    FontFace: 'primary',
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    fontFamily:'primary',
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    fontFamily:'primary',
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily:'primary',
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily:'primary',
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    fontFamily:'primary',
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  }
};
